module.exports = __webpack_public_path__ + "img/evalred.ad55da9e.svg";